'use client'
import { Fragment } from 'react'
import { Popover, Transition } from '@headlessui/react'

const Disclosure = ({ items }) => (
  <div className="mt-20 ml-12 mr-10 mb-20 lg:mr-20">
    {items.map((item, idx) => {
      return (
        <div
          key={idx}
          className={`border-t border-blue ${
            idx + 1 === items.length ? 'border-b border-blue' : null
          }`}
        >
          <Popover className="">
            <Popover.Button className="outline-none w-full group  text-blue hover:text-white hover:bg-blue">
              {({ open }) => {
                return (
                  <>
                    <div className="flex place-content-between">
                      <p className="text-left text-[24px] lg:text-[36px] font-alliance-medium pt-6 pb-4 lg:mr-60 pl-4">
                        {item?.titulo}
                      </p>

                      <div className="min-w-[75px] my-4 ml-6 pr-4">
                        {open ? (
                          <>
                            <img
                              src={`/assets/icons/arrow-circle-right.svg`}
                              alt="icon"
                              className="transition rotate-90 w-16 lg:w-full block group-hover:hidden"
                            />
                            <img
                              src={`/assets/icons/arrow-circle-right-white.svg`}
                              alt="icon"
                              className="transition rotate-90 w-16 lg:w-full hidden group-hover:block"
                            />
                          </>
                        ) : (
                          <>
                            <img
                              src={`/assets/icons/arrow-circle-right.svg`}
                              alt="icon"
                              className="transition rotate-0 w-16 lg:w-full block group-hover:hidden"
                            />
                            <img
                              src={`/assets/icons/arrow-circle-right-white.svg`}
                              alt="icon"
                              className="transition rotate-0 w-16 lg:w-full hidden group-hover:block"
                            />
                          </>
                        )}
                      </div>
                    </div>
                    <Transition
                      as={Fragment}
                      enter="transition ease-out duration-200"
                      enterFrom="opacity-0 -translate-y-1"
                      enterTo="opacity-100 translate-y-0"
                      leave="transition ease-in duration-150"
                      leaveFrom="opacity-100 translate-y-0"
                      leaveTo="opacity-0 -translate-y-1"
                    >
                      <Popover.Panel className="transform">
                        <p className="flex text-left text-[18px] lg:text-[22px] pb-6 lg:mr-60 pl-4">
                          {item?.contenido}
                        </p>
                      </Popover.Panel>
                    </Transition>
                  </>
                )
              }}
            </Popover.Button>
          </Popover>
        </div>
      )
    })}
  </div>
)

export default Disclosure
